<div mat-dialog-content>
  <div class="mat-dialog-content">
    @if (procedureModel) {
      <form appFormscroll class="form" [formGroup]="procedureModel" (ngSubmit)="submit()">
        <div class="body-modal">
          <div class="title-header">
            <h1>Dados do procedimento</h1>
          </div>
          <div class="row">
            <div class="col-12 col-sm-6 col-md-3">
              <mat-form-field appearance="outline">
                <mat-label>17 - Data de realização</mat-label>
                <input matInput type="text" [mask]="masks.date" formControlName="procedureDate">
                @if (procedureModel.get('procedureDate').invalid) {
                  <mat-error>Preenchimento
                  incorreto</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="col-12 col-sm-6 col-md-2">
              <mat-form-field appearance="outline">
                <mat-label>18 - Hora inicial</mat-label>
                <input matInput type="text" [mask]="masks.fullTime.mask"
                  [maxlength]="feesFieldsMaxLengthEnum.guideNumber"
                  formControlName="procedureStartDatetime">
                  @if (procedureModel.get('procedureStartDatetime').invalid && !procedureModel.get('procedureStartDatetime').errors?.maxlength) {
                    <mat-error
                      >Preenchimento
                    incorreto</mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col-12 col-sm-6 col-md-2">
                <mat-form-field appearance="outline">
                  <mat-label>19 - Hora Final</mat-label>
                  <input matInput type="text" [mask]="masks.fullTime.mask"
                    [maxlength]="feesFieldsMaxLengthEnum.guideNumber"
                    formControlName="procedureEndDatetime">
                    @if (procedureModel.get('procedureEndDatetime').invalid && !procedureModel.get('procedureEndDatetime').errors?.maxlength) {
                      <mat-error
                        >Preenchimento
                      incorreto</mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-12 col-sm-6 col-md-5">
                  <mat-form-field appearance="outline">
                    <mat-label>20 - Tabela</mat-label>
                    <mat-select formControlName="idTerminologyGroup" (selectionChange)="selectTable()">
                      @for (item of tussTerminologyGroupMap | keyvalue; track item) {
                        <mat-option
                          [value]="item.value.idTerminologyGroup" [disabled]="item.value.idTerminologyGroup !== procedimentos">{{item.value.terminologyGroupCode}} -
                          {{item.value.nameTerminologyGroup}}
                        </mat-option>
                      }
                    </mat-select>
                    @if (procedureModel.get('idTerminologyGroup').invalid && !procedureModel.get('idTerminologyGroup').errors?.maxlength) {
                      <mat-error
                        >Preenchimento
                      incorreto</mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-12 col-sm-6 col-md-6">
                  <mat-form-field appearance="outline">
                    <mat-label>21/22 - Cód. do procedimento/Descrição</mat-label>
                    <mat-select formControlName="procedure" (selectionChange)="selectProcedure($event.value)"
                      [disabled]="!this.isEditingAllowed">
                      <input class="inputSearchSelect" type="text" (keyup)="onKey($event.target.value)"
                        placeholder="Pesquisar" autocomplete="off" (keydown)="$event.stopPropagation()">
                        @for (item of listProcedure; track item) {
                          <mat-option
                            [value]="item">{{item.terminology.terminologyCode}} -
                            {{item.terminology.terminologyName}}
                          </mat-option>
                        }
                      </mat-select>
                      @if (procedureModel.get('procedure').invalid) {
                        <mat-error>Preenchimento
                        incorreto</mat-error>
                      }
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-sm-4 col-md-3">
                    <mat-form-field appearance="outline">
                      <mat-label>23 - Qtde.</mat-label>
                      <input matInput type="text" (keyup)="onChangeTotalValue()"
                        [maxlength]="feesFieldsMaxLengthEnum.procedureCount" formControlName="procedureCount"
                        (input)="inputNumberMinOne('procedureCount')">
                        @if (procedureModel.get('procedureCount').invalid && !procedureModel.get('procedureCount').errors?.maxlength) {
                          <mat-error
                            >Preenchimento
                          incorreto</mat-error>
                        }
                        <mat-hint align="end">{{ procedureModel.get('procedureCount').value ?
                          procedureModel.get('procedureCount').value.length : 0
                        }}/{{feesFieldsMaxLengthEnum.procedureCount}}</mat-hint>
                      </mat-form-field>
                    </div>
                    <div class="col-12 col-sm-4 col-md-3">
                      <mat-form-field appearance="outline">
                        <mat-label>24 - Via</mat-label>
                        <mat-select formControlName="idAccess" (selectionChange)="onChangeAccess()">
                          <mat-option ngValue="null">Selecione</mat-option>
                          @for (item of accessMap | keyvalue; track item) {
                            <mat-option
                              [value]="item.key">{{item.value.accessLookupCode}} -
                              {{item.value.accessDescription}}
                            </mat-option>
                          }
                        </mat-select>
                        @if (procedureModel.get('idAccess').invalid) {
                          <mat-error>Preenchimento
                          incorreto</mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="col-12 col-sm-4 col-md-3">
                      <mat-form-field appearance="outline">
                        <mat-label>25 - Tec.</mat-label>
                        <mat-select formControlName="idTechnique">
                          <mat-option ngValue="null">Selecione</mat-option>
                          @for (item of techniqueMap | keyvalue; track item) {
                            <mat-option
                              [value]="item.key">{{item.value.techniqueLookupCode}} -
                              {{item.value.techniqueDescription}}
                            </mat-option>
                          }
                        </mat-select>
                        @if (procedureModel.get('idTechnique').invalid) {
                          <mat-error>Preenchimento
                          incorreto</mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="col-12 col-sm-4 col-md-3">
                      <mat-form-field appearance="outline">
                        <mat-label>26 - Fator Red/Acresc.</mat-label>
                        <input matInput type="text" formControlName="adjustmentCoefficient" currencyMask
                          [options]="{ inputMode: 'Natural', prefix: '', decimal: '.', max: '9.99', allowNegative: 'false' }"
                          (keyup)="onChangeTotalValue()">
                          @if (procedureModel.get('adjustmentCoefficient').invalid && !procedureModel.get('adjustmentCoefficient').errors?.maxlength) {
                            <mat-error
                              >Preenchimento
                            incorreto</mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <div class="col-12 col-sm-6 col-md-3">
                        <mat-form-field appearance="outline">
                          <mat-label>27 - Valor Unitário (R$)</mat-label>
                          <input matInput type="text" formControlName="procedureUnitValue" currencyMask
                            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', max: '999999.99', allowNegative: 'false' }"
                            (keyup)="onChangeTotalValue()">
                            @if (procedureModel.get('procedureUnitValue').invalid && !procedureModel.get('procedureUnitValue').errors?.maxlength) {
                              <mat-error
                                >Preenchimento
                              incorreto</mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-6 col-md-3">
                          <mat-form-field appearance="outline">
                            <mat-label>28 - Valor Total</mat-label>
                            <input matInput type="text" formControlName="procedureTotalValue" currencyMask
                              [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', max: '999999.99', allowNegative: 'false' }">
                              @if (procedureModel.get('procedureTotalValue').invalid && !procedureModel.get('procedureTotalValue').errors?.maxlength) {
                                <mat-error
                                  >Preenchimento
                                incorreto</mat-error>
                              }
                            </mat-form-field>
                          </div>
                          <div class="col-12 col-sm-6 col-md-6">
                            <mat-checkbox formControlName="otherApartment" (change)="onChangeAccess()">
                              Apartamento?
                            </mat-checkbox>
                            @if (procedureModel.get('otherApartment').invalid && !procedureModel.get('otherApartment').errors?.maxlength) {
                              <mat-error
                                >Preenchimento
                              incorreto</mat-error>
                            }
                            <mat-checkbox formControlName="otherUrgency" (change)="onChangeAccess()">
                              Urgência?
                            </mat-checkbox>
                            @if (procedureModel.get('otherUrgency').invalid && !procedureModel.get('otherUrgency').errors?.maxlength) {
                              <mat-error
                                >Preenchimento
                              incorreto</mat-error>
                            }
                            <mat-checkbox formControlName="otherDhe" (change)="onChangeAccess()">
                              DHE?
                            </mat-checkbox>
                            @if (procedureModel.get('otherDhe').invalid && !procedureModel.get('otherDhe').errors?.maxlength) {
                              <mat-error
                                >Preenchimento
                              incorreto</mat-error>
                            }
                          </div>
                        </div>
                        <div class="title-header">
                          <h1>Dados dos profissionais</h1>
                          @if (procedureModel.errors?.minProfessionals) {
                            <mat-error>Selecione pelo menos um
                            profissional</mat-error>
                          }
                        </div>
                        @for (item of professionals().controls; track item; let i = $index) {
                          <div class="row list-professionals"
                            formArrayName="listProfessionals">
                            <div class="row" [formGroupName]="i">
                              <div class="col-12 col-sm-6 col-md-3">
                                <mat-form-field appearance="outline">
                                  <mat-label>32 - Profissional</mat-label>
                                  <mat-select formControlName="professionalAgreement"
                                    (selectionChange)="selectProfessional($event,i)"
                                    [disabled]="!this.isEditingAllowed">
                                    <input class="inputSearchSelect" type="text"
                                      (keyup)="onKeyProfessional($event.target.value)" placeholder="Pesquisar"
                                      autocomplete="off" (keydown)="$event.stopPropagation()">
                                      @for (item of listProfessionalAgreementStruct; track item) {
                                        <mat-option
                                          [value]="item">{{item.nameProfessional}}
                                        </mat-option>
                                      }
                                    </mat-select>
                                    @if (professionals().controls[i].get('professionalAgreement').invalid) {
                                      <mat-error
                                        >Preenchimento
                                      incorreto</mat-error>
                                    }
                                  </mat-form-field>
                                </div>
                                <div class="col-12 col-sm-6 col-md-3">
                                  <mat-form-field appearance="outline">
                                    <mat-label>30 - Grau de Participação</mat-label>
                                    <mat-select formControlName="idParticipationDegree">
                                      @for (item of participationDegreeMap | keyvalue; track item) {
                                        <mat-option
                                          [value]="item.key">{{item.value.participationDegreeLookupCode}} -
                                          {{item.value.participationDegreeDescription}}
                                        </mat-option>
                                      }
                                    </mat-select>
                                    @if (professionals().controls[i].get('idParticipationDegree').invalid) {
                                      <mat-error
                                        >Preenchimento
                                      incorreto</mat-error>
                                    }
                                  </mat-form-field>
                                </div>
                                <div class="col-12 col-sm-6 col-md-3">
                                  <mat-form-field appearance="outline">
                                    <mat-label>31 - Código na operadora/CPF</mat-label>
                                    <input matInput type="text" formControlName="professionalProviderCodeOrCpf">
                                    @if (professionals().controls[i].get('professionalProviderCodeOrCpf').invalid && !professionals().controls[i].get('professionalProviderCodeOrCpf').errors?.maxlength) {
                                      <mat-error
                                        >Preenchimento
                                      incorreto</mat-error>
                                    }
                                  </mat-form-field>
                                </div>
                                <div class="col-12 col-sm-6 col-md-3">
                                  <mat-form-field appearance="outline">
                                    <mat-label>36 - Código CBO</mat-label>
                                    <mat-select formControlName="idCbo">
                                      @for (item of cboMap | keyvalue; track item) {
                                        <mat-option
                                          [value]="item.key">{{item.value.cboCode}} -
                                          {{item.value.cboName}}
                                        </mat-option>
                                      }
                                    </mat-select>
                                    @if (professionals().controls[i].get('idCbo').invalid) {
                                      <mat-error>Preenchimento
                                      incorreto</mat-error>
                                    }
                                  </mat-form-field>
                                </div>
                                <div class="col-12 col-sm-6 col-md-5">
                                  <mat-form-field appearance="outline">
                                    <mat-label>33 - Conselho Profissional</mat-label>
                                    <mat-select matInput type="text" formControlName="idCouncil">
                                      @for (item of listProfessionalCouncil; track item) {
                                        <mat-option
                                          [value]="item.idProfessionalCouncil">{{item.termCode}} - {{item.councilName}}
                                        </mat-option>
                                      }
                                    </mat-select>
                                  </mat-form-field>
                                </div>
                                <div class="col-12 col-sm-6 col-md-2">
                                  <mat-form-field appearance="outline">
                                    <mat-label>34 - N° no Conselho</mat-label>
                                    <input matInput type="text" formControlName="professionalCouncilCode">
                                    @if (professionals().controls[i].get('professionalCouncilCode').invalid && !professionals().controls[i].get('professionalCouncilCode').errors?.maxlength) {
                                      <mat-error
                                        >Preenchimento
                                      incorreto</mat-error>
                                    }
                                  </mat-form-field>
                                </div>
                                <div class="col-12 col-sm-6 col-md-2">
                                  <mat-form-field appearance="outline">
                                    <mat-label>35 - UF do Conselho</mat-label>
                                    <mat-select matInput type="text" formControlName="idCouncilState">
                                      @for (item of listState; track item) {
                                        <mat-option [value]="item.idState">{{item.stateCode}}
                                          - {{item.stateInitials}} / {{item.stateName}}
                                        </mat-option>
                                      }
                                    </mat-select>
                                  </mat-form-field>
                                </div>
                                @if (isEditingAllowed != null) {
                                  <div class="col-2">
                                    <button color="primary" mat-mini-fab type="button" (click)="addNext()"
                                      [disabled]="!this.isEditingAllowed">
                                      <mat-icon aria-hidden="false" aria-label="Menu apps">add</mat-icon>
                                    </button>
                                    @if (professionals().controls.length > 1) {
                                      <button color="primary" mat-mini-fab type="button" (click)="removeProfessional(i)"
                                        [disabled]="!this.isEditingAllowed">
                                        <mat-icon aria-hidden="false" aria-label="Menu apps">remove</mat-icon>
                                      </button>
                                    }
                                  </div>
                                }
                                @if (isEditingAllowed == null) {
                                  <div class="col-2">
                                    <button color="primary" mat-mini-fab type="button" (click)="addNext()">
                                      <mat-icon aria-hidden="false" aria-label="Menu apps">add</mat-icon>
                                    </button>
                                    @if (professionals().controls.length > 1) {
                                      <button color="primary" mat-mini-fab type="button" (click)="removeProfessional(i)"
                                        >
                                        <mat-icon aria-hidden="false" aria-label="Menu apps">remove</mat-icon>
                                      </button>
                                    }
                                  </div>
                                }
                              </div>
                            </div>
                          }
                        </div>
                        <div mat-dialog-footer class="footer-modal">
                          <button mat-flat-button color="accent" class="btn-block" (click)="close()" type="button">
                            @if (!isLoading) {
                              <span>Cancelar</span>
                            }
                            @if (isLoading) {
                              <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                            }
                          </button>
                          @if (isEditingAllowed != null) {
                            <button mat-flat-button type="submit" color="primary" class="btn-block"
                              [disabled]="!this.isEditingAllowed">
                              @if (!isLoading) {
                                <span>Salvar</span>
                              }
                              @if (isLoading) {
                                <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                              }
                            </button>
                          }
                          @if (isEditingAllowed == null) {
                            <button mat-flat-button type="submit" color="primary"
                              class="btn-block">
                              @if (!isLoading) {
                                <span>Salvar</span>
                              }
                              @if (isLoading) {
                                <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                              }
                            </button>
                          }
                        </div>
                      </form>
                    }
                  </div>
                </div>